import { gql } from '@apollo/client';
import Fragments from './fragments';

export const INCOME_SOURCE_UPDATED = gql`
  subscription incomeSourceUpdated {
    incomeSourceUpdated {
      incomeSource {
        ...incomeSourceItem
      }
    }
  }
  ${Fragments.incomeSourceItem}
`;

export const INCOME_SOURCE_DETAIL_UPDATED = gql`
  subscription incomeSourceDetailUpdated {
    incomeSourceDetailUpdated {
      incomeSourceDetail {
        ...incomeSourceDetailItem
      }
    }
  }
  ${Fragments.incomeSourceDetailItem}
`;

export const INCOME_SOURCE_DETAIL_DELETED = gql`
  subscription incomeSourceDetailDeleted {
    incomeSourceDetailDeleted {
      incomeSourceDetailId
    }
  }
`;
